import React from 'react';
import { observer } from 'mobx-react-lite';
import { BetActionPanel, DecisionActionPanel, InsurancePanel } from '../../components';
import { gameStore } from '../../store/gameStore';
import { INSURANCE_TYPE } from '../../enums/constants';

const ControlPanel = observer(() => {
  const { isBetsClosed, isShowDecision, possibleActions } = gameStore;

  return (
    <>
      {!isBetsClosed && <BetActionPanel />}
      {possibleActions.includes(INSURANCE_TYPE) && <InsurancePanel />}
      {isShowDecision && !possibleActions.includes(INSURANCE_TYPE) && (
        <DecisionActionPanel possibleActions={possibleActions} />
      )}
    </>
  );
});
export default ControlPanel;
